import * as Yup from "yup";

import { getInjuriesSchema } from "Components/Form/RecentDamages/validation";
import { TextManager } from "Components/TextContext";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { ElectricScooterProductIntroFormValues } from "./interface";

export const validationSchema =
  (): Yup.ObjectSchema<ElectricScooterProductIntroFormValues> => {
    const { getText } = TextManager;

    return Yup.object()
      .shape({
        topSpeed: Yup.mixed<BooleanFormType>()
          .required(getText("electricscooterform.validation.topspeed"))
          .oneOf(
            [BooleanFormType.TRUE],
            ErrorPrefix.BREAKING +
              getText("electricscooterform.validation.topspeed_invalid"),
          ),
        modelYear: Yup.string().required(
          getText("electricscooterform.validation.modelyear"),
        ),
        brand: Yup.string().required(
          getText("electricscooterform.validation.brand"),
        ),
        model: Yup.string().required(
          getText("electricscooterform.validation.model"),
        ),
      })
      .concat(getInjuriesSchema());
  };
